function regexCheck(string, pattern) {
    try {
        const regex = new RegExp(pattern);
        return regex.test(string);
    } catch (e) {
        console.error('Invalid regex pattern:', pattern, e);
        return false;
    }
}

/**
 * Helper function to check if an address field ID matches standard address field patterns
 * @param {string} fieldId - The field ID to check
 * @param {string} fieldType - The field type ('state' or 'country')
 * @returns {boolean} - True if the ID matches standard address field patterns
 */
function standardAddressFieldPattern(fieldId, fieldType) {
    if (!fieldId || !fieldType) return false;
    
    // Check for billing_/shipping_ fields
    if (fieldId === `billing_${fieldType}` || fieldId === `shipping_${fieldType}`)
        return true;
    
    // Check for numbered state/country fields (e.g., state_1, country_2)
    if (regexCheck(fieldId, `^${fieldType}_(\\d+)`))
        return true;
    
    // Check for contact person address fields (e.g., address_cp_1_state, address_cp_2_country)
    if (regexCheck(fieldId, `^address_cp_(\\d+)_${fieldType}`))
        return true;
    
    // Check for contact address fields (e.g., address_ct_1_state, address_ct_2_country)
    if (regexCheck(fieldId, `^address_ct_(\\d+)_${fieldType}`))
        return true;
    
    return false;
}

// Helper function to remove error classes if element has valid value
function removeErrorsIfValid($element, elementName) {
    if($element && $element.length > 0) {
        $element.removeClass('am-error-border validation-failed');

        if(am.$('.order_info').length == 0){ // non order pages
            const $label = $element.closest('.am-section-row').find('.am-section-label');
            $label.removeClass('am-error-text'); 
            const $err_label = $element.closest('.am-section-row').find('.error-msg');
            $err_label.remove();
        }else{ // Order page
            const $err_label = am.$('.validation-advice#_'+$element.attr('id'));
            if($err_label.length > 0) $err_label.remove();
            const $err_label_2 = am.$('#repeat_errors').children('#_'+$element.attr('id')+'_2');
            if($err_label_2.length > 0) $err_label_2.remove();
        }
    }
}

function addStateLoadingOption(address_id){
    var $state;
    if(address_id == 0){
        $state = am.$('#state');
    }
    else{
        if(standardAddressFieldPattern(address_id, 'state'))
            $state = am.$('#'+address_id);
        else
            $state = am.$('.places_state_'+address_id);
    }

    var $opt = am.$(`<option value="" id="loading-option_${address_id}">Loading...</option>`);

    if($state.length > 0)
        $state.append($opt);
    else
        console.log('state not found');
}

function removeStateLoadingOption(address_id){
    var $opt = am.$(`#loading-option_${address_id}`);
    if($opt.length > 0)
        $opt.remove();
    else
        console.log('loading option not found');
}

function addStateOptions($stateSel, data){
    if(data && data.states && data.states.length > 0){
        data.states.each((state) => {
            var state_opt = am.$(`<option value="${state.id}">${state.value}</option>`);
            $stateSel.append(state_opt);
        });
    }
    else{
        console.log('states not found');
    };
}

function setState($stateSel, state_value){
    if($stateSel.length == 0) return;
    
    if(state_value == ''){
        var selectOpt = am.$(`<option value="" >Select</option>`);
        $stateSel.prepend(selectOpt).val('');
    }
    else{
        $stateSel.val(state_value);
    }
    
}
function removeStateOptions (address_id) {
    var opts = [];
    if(address_id == 0){
        opts = am.$('.places_state').children('option');
    }
    else{
        if(standardAddressFieldPattern(address_id, 'state'))
            opts = am.$('#'+address_id).children('option');
        else
            opts = am.$('.places_state_'+address_id).children('option');
    }

    if(opts.length > 0){
        opts.each((i, opt) => {
            am.$(opt).remove();
        })
    }else{
        console.log('options not found');
    }
}

function check_opts($stateSel, val){
    var opts = $stateSel.children('option');
    var has_match = [];
    
    opts.each((i, opt) => {
        if(val == opt.value)
            has_match.push(true);
    })

    if(has_match.length > 0 )
      return true;
    else  
      return false
}

/**
 * Used to format the address_object for the update_states_on_country_change function when passed as strings from .tpl
 * @param {string} name - The name of the address
 * @param {string} nameval - The value of the name
 * @param {string} state_id - The ID of the state
 * @param {string} country_id - The ID of the country
 * @param {string} state_name - The name of the state
 * @param {string} zip_id - The ID of the zip
 * @param {string} set_state - The state to set
 */
function handle_address_change(name, nameval , state_id, country_id, state_name, zip_id, set_state){ // for .tpl pages and obj formatting
	update_states_on_country_change({ name:name, nameval:nameval, state_id:state_id, country_id:country_id, state_name:state_name, zip_id:zip_id, set_state:set_state });
}

// Helper function to get address element by ID and type
function getAddressElement(id, type) {
    if (id == 0) {
        return am.$(type === 'country' ? '.places_country' : '#state');
    }
    
    const isStandard = standardAddressFieldPattern(id, type);
    return isStandard ? am.$('#' + id) : am.$(`.places_${type}_${id}`);
}

// Helper function to create state input/select element
function createStateElement(stateId, elementType, isStandard) {
    const isDefault = stateId == 0;
    const baseClasses = isDefault ? 'places_state' : `places_state_${stateId}`;
    
    if (elementType === 'input') {
        if (isDefault) {
            return `<input type="text" class="places_state" required style="width: 102%" id="state" name="address[state]">`;
        }
        const inputClass = isStandard ? 'am-section-input js-required' : 'am-nestedInput';
        return `<input type="text" class="${inputClass} ${baseClasses}" id="${stateId}" name="address[${stateId}][state]">`;
    } else {
        if (isDefault) {
            return `<select id='state' name='address[state]' required style="width: 102%" class="places_state">`;
        }
        const selectClass = isStandard ? 'am-select-dropdown js-required' : 'am-nestedDropdown';
        return `<select class="${selectClass} ${baseClasses}" id="${stateId}" name="address[${stateId}][state]">`;
    }
}

// Helper function to manage loading state cleanup
function cleanupLoading() {
    setTimeout(() => {
        if (Ajax.activeRequestCount === 0) {
            hide_loading_svg();
        }
    }, 1000);
}

/**
 * Used to update the states on the country change
 * @param {object, number} address_obj - The address object or the address ID
 * if number, it is the address ID and the address object will be formatted accordingly
 */
async function update_states_on_country_change(address_obj) {
    show_loading_svg();
    
    // Normalize address_obj if it's a number (or a numeric string, as the new-address block template passes)
    if (typeof address_obj == 'number' || (typeof address_obj == 'string' && /^\d+$/.test(address_obj))) {
        address_obj = {
            state_id: 'state_' + address_obj,
            country_id: 'country_' + address_obj,
            zip_id: 'zip_' + address_obj,
            set_state: '',
            country_value: '',
        };
    }

    if (isDebugMode()) console.log(address_obj, 'address_obj');

    // Setup initial state
    removeStateOptions(address_obj.state_id);
    addStateLoadingOption(address_obj.state_id);
    
    const $countrySel = getAddressElement(address_obj.country_id, 'country');
    
    if ($countrySel.length === 0) {
        setTimeout(() => hide_loading_svg(), 100);
        return;
    }

    try {
        await am.$.getJSON('/ajax/states/get_states_by_country/?country=' + $countrySel.val())
            .done(function(data) {
                const $stateSel = getAddressElement(address_obj.state_id, 'state');
                const isStandard = standardAddressFieldPattern(address_obj.state_id, 'state');
                
                if (data == 0) {
                    // No states available - replace with text input
                    const inputHtml = createStateElement(address_obj.state_id, 'input', isStandard);
                    $stateSel.hide().after(am.$(inputHtml)).remove();
                } else if (data.states && data.states.length > 0) {
                    removeStateLoadingOption(address_obj.state_id);
                    
                    // Convert input to select if needed
                    if ($stateSel.prop('tagName') === 'INPUT') {
                        const selectHtml = createStateElement(address_obj.state_id, 'select', isStandard);
                        $stateSel.hide().after(am.$(selectHtml)).remove();
                    }
                    
                    const $newStateSel = getAddressElement(address_obj.state_id, 'state');
                    addStateOptions($newStateSel, data);
                    setState($newStateSel, address_obj.set_state);

                    // Handle data-state attribute
                    const val = $newStateSel.attr('data-state');
                    if (val && val.length > 0) {
                        if (!check_opts($newStateSel, val)) {
                            $newStateSel.append(new Option(val, val));
                            $newStateSel.selected = val;
                        }
                        googleplaces();
                    }
                    
                    removeErrorsIfValid($newStateSel, 'state');
                }

                // Post-processing
                setTimeout(() => set_zip_validation_by_country(address_obj.zip_id), 100);
                // DEV-12923: orders.js is page-bundled (js-orders); this address form also
                // renders on account/payment pages, where the shipping group does not exist.
                if (typeof shipping_method_changed === 'function') shipping_method_changed();
                removeErrorsIfValid($countrySel, 'country');
                cleanupLoading();
            })
            .fail(function(e) {
                console.log(e);
            })
            .always(function() {
                setTimeout(() => hide_loading_svg(), 100);
            });
    } catch (e) {
        console.log(e);
        setTimeout(() => hide_loading_svg(), 100);
    }
}

function set_zip_validation_by_country(zip_id){
    console.log(zip_id, 'zip_id');
	const $zip = am.$(`#zip_${zip_id}`);
	const $country = am.$(`#country_${zip_id}`);

	if($country.val() == 'Australia')
		$zip.addClass('validate-zip-aus').removeClass('validate-zipc');
	else
		$zip.addClass('validate-zipc').removeClass('validate-zip-aus');
}